exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "admin-users {\n  display: block;\n  margin-bottom: 20px;\n}", ""]);

// exports
